import { z } from 'zod'

export interface GeoPoint {
  longitude: number
  latitude: number
}

export const isGeoPoint = (data: unknown): data is GeoPoint =>
  data !== null &&
  typeof data === 'object' &&
  'longitude' in data &&
  typeof data.longitude === 'number' &&
  'latitude' in data &&
  typeof data.latitude === 'number'

export const GeoPointZod = z.custom<GeoPoint>((data): data is GeoPoint => isGeoPoint(data))
